import { STEP_INDICES, STEPS } from "../progressSteps";

interface ProgressStepBarProps {
  currentStep: keyof typeof STEPS;
}

export default function ProgressStepBar({ currentStep }: ProgressStepBarProps) {
  const stepOrder: Array<keyof typeof STEPS> = [
    "SELECT_VEHICLE",
    "SELECT_SERVICE",
    "SELECT_TIME_SLOT",
    "CONFIRMATION",
  ];

  const currentIndex = stepOrder.indexOf(currentStep);

  return (
    <div style={{
      padding: "var(--space-lg) 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 0,
    }}>
      {stepOrder.map((step, index) => {
        const stepInfo = STEPS[step];
        const isCompleted = index < currentIndex;
        const isCurrent = index === currentIndex;
        const isPending = index > currentIndex;
        const isLast = index === stepOrder.length - 1;

        return (
          <div key={step} style={{
            display: "flex",
            alignItems: "center",
            flex: isLast ? 0 : 1,
          }}>
            {/* Step circle */}
            <div style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "13px",
              fontWeight: 600,
              background: isCompleted
                ? "var(--emerald-500)"
                : isCurrent
                  ? "var(--blue-500)"
                  : "var(--stone-200)",
              color: isCompleted || isCurrent ? "var(--white)" : "var(--stone-500)",
              transition: "all 0.2s ease",
              flexShrink: 0,
            }}>
              {isCompleted ? (
                <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3}>
                  <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              ) : index + 1}
            </div>

            {/* Step label */}
            <span style={{
              marginLeft: "10px",
              fontSize: "13px",
              fontWeight: isCurrent ? 600 : 500,
              color: isCompleted
                ? "var(--emerald-600)"
                : isCurrent
                  ? "var(--blue-600)"
                  : "var(--stone-400)",
            }}>
              {stepInfo.title}
            </span>

            {/* Connector line (except for last step) */}
            {!isLast && (
              <div style={{
                width: "100%",
                height: "2px",
                background: isCompleted
                  ? "var(--emerald-500)"
                  : "var(--stone-200)",
                marginLeft: "10px",
                marginRight: "10px",
                flex: 1,
                minWidth: "40px",
              }} />
            )}
          </div>
        );
      })}
    </div>
  );
}
